import React from 'react';
import {Row, Col} from 'reactstrap';
import {isMobileOnly, isTablet, isMobile} from 'react-device-detect';

const OtpHeadlineComponent = (props) => {
  return (
    <div className={`otp-headline-wrapper`}>
      {props.title && <Col className={`col-12 otp-headline-title pr-0 pl-0 `}>{props.title}</Col>}
      {props.description && <Col className={`otp-headline-description col-12 pr-0 pl-0`}>{props.description}</Col>}
      {props.codeEnterText && <Col className={`otp-headline-codeEnter col-12  pr-0 pl-0`}>{props.codeEnterText}</Col>}
    </div>
  );
};
export default OtpHeadlineComponent;
